(function() {
    'use strict';

    angular
        .module('searchApp')
        .controller('CompReportWarningDialogController',CompReportWarningDialogController);

    CompReportWarningDialogController.$inject = ['$uibModalInstance','detailMessage'];

    function CompReportWarningDialogController($uibModalInstance,detailMessage) {
        var vm = this;
        vm.confirm = confirm;
        vm.detailMessage = detailMessage;
        
        function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
